// extracted by mini-css-extract-plugin
export default {"container":"hE-z","heading":"iE-z","text":"jE-z","info":"kE-z","link":"lE-z","fullMaxWidth":"mE-z"};